import React, { Dispatch, SetStateAction } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { SelectProps } from "@material-ui/core/Select";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { StyledGrid } from "components/simple";
import { color } from "style/constants";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface CustomProps {
  callback?: Dispatch<string | number>;
  defaultText: string;
  disabled?: boolean;
  options: OptionObj[];
  valuesArr: OptionObj[];
  setValuesArr: Dispatch<SetStateAction<{ id: string; name: string }[]>>;
  limit?: number;
}

export interface OptionObj {
  id: string;
  name: string;
}

type DropdownProps = CustomProps & SelectProps;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    "&, &:before, &:after": {
      borderBottomWidth: "0px !important",
      color: "#aeaeae",
      fontSize: "16px"
    }
  }
}));

const DropdownMultipleSearch: React.FC<DropdownProps> = ({
  callback,
  defaultText,
  disabled,
  options,
  valuesArr,
  setValuesArr,
  limit,
  ...otherProps
}: DropdownProps) => {
  const classes = useStyles();
  const currentValue = options.filter(coach => {
    if (valuesArr.find(c => c.id === coach.id)) return coach;
  });
  return (
    <StyledGrid container width="100%">
      <StyledGrid item xs={12}>
        <Autocomplete
          id="checkboxes-tags-demo"
          fullWidth
          multiple
          disableCloseOnSelect
          options={options}
          value={currentValue}
          getOptionLabel={option => option.name}
          onChange={(_, obj) => {
            if (limit) if (obj.length > limit) obj.length = limit;
            setValuesArr(obj);
          }}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.name}
            </React.Fragment>
          )}
          className={classes.root}
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label={defaultText}
              InputLabelProps={{ style: { color: "#aeaeae", background: color.WHITE } }}
            />
          )}
        />
      </StyledGrid>
    </StyledGrid>
  );
};

export default DropdownMultipleSearch;
